import React from 'react'
import ReviewSubmission from './form/ReviewSubmission'
import FacilityAliasForm from './form/FacilityAliasForm'
import DNRInformationTab from './form/dnrInformationTab/DNRInformationTab'
import FacilitySelectionForm from './form/FacilitySelection'
import ViewMapTab from './form/viewMapTab/ViewMapTab'
import FacilityAssignment from './form/facilityAssignment/FacilityAssignment'

export default (
    formType,
    configuredNavGroups,
    isSearchTabVisible,
    isReview,
    isViewMapVisible
) => {
    let allNavGroups = configuredNavGroups

    const aliasTab = {
        groupName: 'Well Alias Information',
        requires: null,
        type: 'component',
        component: FacilityAliasForm,
        dataAccessor: 'facilityAlias',
    }

    const reviewTab = {
        groupName: 'Review',
        requires: null,
        type: 'component',
        component: ReviewSubmission,
        dataAccessor: 'facility',
    }

    const dnrInformationTab = {
        groupName: 'DNR Information',
        requires: null,
        type: 'component',
        component: DNRInformationTab,
        dataAccessor: 'dnrInformation',
    }

    const searchTab = {
        groupName: 'Well Search',
        requires: null,
        type: 'component',
        component: FacilitySelectionForm,
        dataAccessor: 'facility',
    }

    const viewMap = {
        groupName: 'View in Map',
        requires: null,
        type: 'component',
        component: () => <ViewMapTab formType={formType} />,
        dataAccessor: 'viewMap',
    }

    const wellMergeAssignment = {
        groupName: 'Filter Wells',
        requires: null,
        type: 'component',
        component: FacilityAssignment,
        dataAccessor: 'mergeWells',
    }

    switch (formType.FormType) {
        case 'WellMerge':
            allNavGroups = [wellMergeAssignment, viewMap, ...allNavGroups]
            break
        default:
            //facility sample results
            allNavGroups = [aliasTab, dnrInformationTab, ...allNavGroups]
            if (isSearchTabVisible) {
                allNavGroups = [searchTab, ...allNavGroups]
            }
            if (isViewMapVisible) {
                allNavGroups = [...allNavGroups, viewMap]
            }
            break
    }

    if (isReview) {
        allNavGroups = [...allNavGroups, reviewTab]
    }

    return allNavGroups
}
